import React from "react";
import CarouselSlider from "./sections/carouselSlider";
import LatestNews from "./sections/latestNews";
import Notices from "./sections/notices";
import Services from "./sections/services";
import Stakeholders from "./sections/stakeholders";

const Index = () => {
  return (
    <>
      <CarouselSlider />
      <LatestNews />
      <Services />
      <Notices />
      <Stakeholders />
    </>
  );
};

export default Index;
